module.exports = "/images/sort_desc.png?24952cb1e8d115941c6f7eec6c88e993";